var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTodoRelease = function SvgTodoRelease(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.069 12.009",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "edit (1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.14 7.536a.3.3 0 0 0-.3.3v2.669a.9.9 0 0 1-.9.9H1.5a.9.9 0 0 1-.9-.9V2.672a.9.9 0 0 1 .9-.9h2.672a.3.3 0 1 0 0-.6H1.5a1.5 1.5 0 0 0-1.5 1.5v7.833a1.5 1.5 0 0 0 1.5 1.5h8.437a1.5 1.5 0 0 0 1.5-1.5V7.836a.3.3 0 0 0-.3-.3Zm0 0",
    "data-name": "Pfad 1323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.321.396a1.353 1.353 0 0 0-1.913 0L4.046 5.759a.3.3 0 0 0-.077.132l-.707 2.548a.3.3 0 0 0 .37.37l2.546-.705a.3.3 0 0 0 .132-.077l5.363-5.363a1.354 1.354 0 0 0 0-1.913ZM4.7 5.954l4.389-4.389 1.415 1.415-4.389 4.389Zm-.283.567 1.131 1.131-1.564.433Zm6.832-4.282-.319.319-1.416-1.419.319-.319a.75.75 0 0 1 1.063 0l.353.353a.753.753 0 0 1 0 1.066m0 0",
    "data-name": "Pfad 1324"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTodoRelease);
export default ForwardRef;